import SectionOurClients from "components/SectionOurClients/SectionOurClients";
import HeroSection from "components/HeroSection/HeroSection";
import KeyCapabilitiesPanel from "components/KeyCapabilitiesSection/KeyCapabilitiesPanel";
import SectionHowItWorks from "components/SectionHowItWork/SectionHowItWork";

function PageHome() {
  return (
    <div className="nc-PageHome relative overflow-hidden">
      <div className="relative">
        <HeroSection />
        <SectionOurClients />
        <KeyCapabilitiesPanel />
        <SectionHowItWorks />
      </div>
    </div>
  );
}

export default PageHome;
